export default __webpack_public_path__ + "355e686.png";